/** Keep the exact request until an uncertain result has been reconciled. */
export type SavedRequest = { path: string; init: RequestInit; fingerprint: string };
const pending = new Map<string, SavedRequest>();
const storageKey=(scope:string)=>`estet:content-request:${scope}`;
export function pendingRequest(scope: string) {
  if(!pending.has(scope))try{
    const saved=JSON.parse(sessionStorage.getItem(storageKey(scope))||"null");
    if(saved&&typeof saved.path==="string"&&typeof saved.fingerprint==="string"&&typeof saved.init?.body==="string")pending.set(scope,saved);
  }catch{/* Storage is optional; the in-memory request still survives a form remount. */}
  return pending.get(scope) ?? null;
}
export function retainRequest(scope: string, request: SavedRequest) {
  pending.set(scope, request);
  if(typeof request.init.body==="string")try{sessionStorage.setItem(storageKey(scope),JSON.stringify(request));}catch{/* Private browser. */}
}
export function clearRequest(scope: string) {
  pending.delete(scope);try{sessionStorage.removeItem(storageKey(scope));}catch{/* Private browser. */}
}
export function responseUncertain(error: unknown): boolean {
  const status = (error as { status?: number } | null)?.status;
  return status == null || status === 408 || status >= 500;
}
export function contentListParams(mode: string, filter: string, query: string, bagId?: string) {
  return new URLSearchParams({ mode, query, ...(!bagId && filter !== "all" ? { filter } : {}) });
}
export function trialRequest(payload: {revision:number;request_id:string;scene:string;price:string;product_id?:string}, files?:File[]):RequestInit {
  // Keep this allowlist aligned with prompt_editor_web.py's multipart contract.
  const fields={revision:payload.revision,request_id:payload.request_id,scene:payload.scene,price:payload.price,
    ...(payload.product_id?{product_id:payload.product_id}:{})};
  if(!files)return {method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(fields)};
  const body=new FormData();Object.entries(fields).forEach(([key,value])=>body.set(key,String(value)));
  files.forEach(file=>body.append("photos",file));return {method:"POST",body};
}
